import { provideChameleonDesignSystem } from '../provideChameleonDesignSystem';
import { chameleonSnackbar } from './Snackbar.definition';
export function registerCustom(prefix, node) {
    return provideChameleonDesignSystem({ prefix, node }).register(chameleonSnackbar({ prefix }));
}
